import request from 'superagent';

request.delete = request.del;
